import React from 'react'
import cl from 'classnames'
import { PageContainerProps } from './types'
import styles from './PageContainer.module.scss'
import { presets } from './presets'

const PageContainer = (props: PageContainerProps) => {
  const { children, maxHeight = false, preset = 'primary' } = props

  const containerStyles = cl(presets[preset], { [styles.maxHeight]: maxHeight })

  return (
    <div className={containerStyles}>
      {children}
    </div>
  )
}

export { PageContainer }
